import http from 'axios'

export default {
  getEvolutionPrixContratGestionDeleguee: (codeRegion, anneeRecolte, codeGraineRs3) => {
    return http.get(`/web/v1/prix/gestion-deleguee/evolution?codeRegion=${codeRegion}&anneeRecolte=${anneeRecolte}&codeGraineRs3=${codeGraineRs3}`)
  }
}
